import React from "react";
import classes from "./Spinner.module.css";

const spinner = () => (
  <div className={classes.Wrapper}>
    <div className={classes.Loader}>Loading...</div>
  </div>
);

export default spinner;
